'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fetchEverywhere = require('fetch-everywhere');

var _fetchEverywhere2 = _interopRequireDefault(_fetchEverywhere);

var _mobxReact = require('mobx-react');

var _Webform = require('../Webform');

var _Webform2 = _interopRequireDefault(_Webform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_STATES = {
  LOADING: 0,
  SUCCESS: 1,
  ERROR: 2
};

var FetchForm = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FetchForm, _Component);

  function FetchForm(props) {
    (0, _classCallCheck3.default)(this, FetchForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FetchForm.__proto__ || (0, _getPrototypeOf2.default)(FetchForm)).call(this, props));

    _this.state = {
      loadState: LOAD_STATES.LOADING
    };

    _this.fetchForm = _this.fetchForm.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(FetchForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchForm();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.baseUrl !== this.props.baseUrl || prevProps.path !== this.props.path || prevProps.field !== this.props.field) {
        this.fetchForm();
      }
    }
  }, {
    key: 'fetchForm',
    value: function fetchForm() {
      var _this2 = this;

      if (!this.props.baseUrl) {
        this.setState({ loadState: LOAD_STATES.ERROR });
        return;
      }

      // console.info('Loading..');
      this.setState({ loadState: LOAD_STATES.LOADING });

      this.fetch = (0, _fetchEverywhere2.default)(this.props.baseUrl + '/url?url=/' + this.props.path + '&_format=json').then(function (data) {
        return data.json();
      }).then(function (json) {
        if ((0, _typeof3.default)(json.content) !== 'object' || !_this2.props.field && !json.content.form_id || _this2.props.field && !json.content[_this2.props.field].form_id) {
          throw Error('Combination of url && field didn\'t work');
        }
        // console.info('JSON!', json.content[this.props.field]);
        _this2.setState({
          form: _this2.props.field ? json.content[_this2.props.field] : json.content,
          loadState: LOAD_STATES.SUCCESS
        });
      }).catch(function (error) {
        console.error('Error loading form:', error);
        _this2.setState({ loadState: LOAD_STATES.ERROR });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      switch (this.state.loadState) {
        case LOAD_STATES.LOADING:
          return _react2.default.createElement(
            'div',
            null,
            'LOADING..'
          );
        case LOAD_STATES.ERROR:
          return _react2.default.createElement(
            'div',
            null,
            'ERROR LOADING FORM.'
          );
        case LOAD_STATES.SUCCESS:
          return _react2.default.createElement(_Webform2.default, {
            form: this.state.form,
            settings: {
              title: 'Form',
              postUrl: this.props.baseUrl + '/form?_format=json',
              postcodeApiKey: 'KlPuqvDkZk3pERM81Epi74Bof4FwrBPLMMNtm83a'
            },
            onSubmit: function onSubmit() {
              var block = false;
              console.info('submithook, block:', block);
              return _promise2.default.resolve({
                submit: !block,
                errors: ['Custom error, override submit']
              });
            },
            onAfterSubmit: function onAfterSubmit() {
              return console.info('afterhook');
            }
          });
        default:
          return null;
      }
    }
  }]);
  return FetchForm;
}(_react.Component), _class2.propTypes = {
  baseUrl: _propTypes2.default.string.isRequired,
  path: _propTypes2.default.string.isRequired,
  field: _propTypes2.default.string
}, _class2.defaultProps = {
  field: 'field_form'
}, _temp)) || _class;

exports.default = FetchForm;